import { render, staticRenderFns } from "./expensesnote.vue?vue&type=template&id=274c5597"
import script from "./expensesnote.vue?vue&type=script&lang=js"
export * from "./expensesnote.vue?vue&type=script&lang=js"
import style0 from "./expensesnote.vue?vue&type=style&index=0&id=274c5597&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports